// FE-SCRM-052 — REST client for the Opportunities list view.
//
// Calls the flat ``GET /api/v1/sales/opportunities`` endpoint
// (BE-SCRM-004 extended with the FE-SCRM-052 filter surface). The
// Renewal Board (BE-SCRM-007) is a separate, richer endpoint shaped
// for the two-axis grid; this list view stays on the flat list so
// pagination + free-text search work without grid geometry.

import { api } from "@/api/client";

import type { OpportunityListResponse } from "./types";


export function fetchOpportunityList(
  query: URLSearchParams,
  opts?: { signal?: AbortSignal },
): Promise<OpportunityListResponse> {
  const qs = query.toString();
  const path = "/api/v1/sales/opportunities" + (qs ? `?${qs}` : "");
  return api.get<OpportunityListResponse>(path, opts);
}
